import React from 'react'
import { useTranslation } from 'next-i18next'
import { DiscountVoucher } from 'src/core/models'
import { getTransformedDate } from 'src/core/helpers'
import { FormLabels, CustomText } from 'src/components'

const DiscountVoucherMovileViewColumn: React.FC<{ discountVoucher: DiscountVoucher }> = ({ discountVoucher }) => {
  const { t } = useTranslation()
  const emailLabel = discountVoucher.is_linked_to_email ? discountVoucher.email : '-'

  return <>
    <FormLabels
      title={discountVoucher.code}
      subtitle={emailLabel}
      thirdLabel={t('Vouchers.ExpirationDate', { date: getTransformedDate(discountVoucher.expiration_date) })}
    />

    <div className='flex-space-between'>
      <CustomText label={getTransformedDate(discountVoucher.created)} />
      <CustomText label={`${discountVoucher.percentage} %`} mark/>
    </div>
  </>
}

export default DiscountVoucherMovileViewColumn
